function isGeologie() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('geologie') !== -1;
}

export default isGeologie;
